import { toDigitsOnly } from '@sravni/creditselection-customer-utils/lib/utils/customers';

export class Snils {
  // eslint-disable-next-line no-empty-function
  constructor(private readonly snils: string | undefined) {}

  map() {
    if (!this.snils) {
      return undefined;
    }

    return toDigitsOnly(this.snils);
  }
}
